export default __webpack_public_path__ + "static/media/hotgiggity.dca21ff6.svg";